import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-likert-scale-2',
  templateUrl: './disable-likert-scale-2.component.html',
  styleUrls: ['./disable-likert-scale-2.component.css'],
})
export class DisableLikertScale2Component {
  @Input() question!: Question;
}
